import styled from 'styled-components';
import { DESKTOP_MEDIA_QUERY, MOBILE_MEDIA_QUERY } from '~/constants';

export const StickyHeaderWrapper = styled.header`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: fixed;
  left: 0px;
  top: 0px;
  z-index: 99;

  ${DESKTOP_MEDIA_QUERY} {
    padding-top: 30px;
    padding-left: 30px;
    padding-right: 30px;
  }

  ${MOBILE_MEDIA_QUERY} {
    padding-top: 20px;
    padding-left: 15px;
    padding-right: 20px;
  }
`;

export const NavContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  ${DESKTOP_MEDIA_QUERY} {
    width: 180px;
  }

  ${MOBILE_MEDIA_QUERY} {
    width: 86.5px;
  }
`;

export const HamburgerButton = styled.button`
  box-sizing: content-box;
  border: none;
  padding: 0;
  cursor: pointer;

  ${DESKTOP_MEDIA_QUERY} {
    width: 50px;
    height: 50px;
  }

  ${MOBILE_MEDIA_QUERY} {
    width: 25px;
    height: 25px;
  }
`;

export const HamburgerButtonIcon = styled.img`
  width: 100%;
  height: 100%;
`;

export const RerootsLogo = styled.div`
  ${DESKTOP_MEDIA_QUERY} {
    width: 115px;
    height: 31px;
  }

  ${MOBILE_MEDIA_QUERY} {
    width: 57.5px;
    height: 15.5px;
  }
`;

export const RerootsLogoIcon = styled.img`
  width: 100%;
  height: 100%;
`;

export const Contact = styled.div`
  border: solid 1px rgb(5, 8, 37);
  background-color: rgb(255, 255, 255);
  display: flex;
  align-items: center;
  justify-content: center;

  ${DESKTOP_MEDIA_QUERY} {
    width: 9.03vw;
    height: 3.47vw;
  }

  ${MOBILE_MEDIA_QUERY} {
    width: 17.33vw;
    height: 6.67vw;
  }
`;

export const ContactText = styled.p`
  text-align: center;
  font-weight: 700;
  line-height: 2.81;
  letter-spacing: 0.1em;
  text-align: center;
  color: #050825;

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 0.78vw;
  }

  ${MOBILE_MEDIA_QUERY} {
    font-size: 1.6vw;
  }
`;
